import '@fancyapps/fancybox';

export class Modal {

    constructor ( target = '.js-modal', options = {} ) {
        this.target = $( target );
        this.options = {
            arrows: false,
            autoFocus: false,
            ...options
        }
    }

    init () {
        $( document ).ready( () => {
            this.target.fancybox( this.options );
        } )
        $(document).on('afterShow.fb', function( e, instance, slide ) {
            document.documentElement.classList.add('js-no-scroll');
        });
        $(document).on('afterClose.fb', function( e, instance, slide ) {
            document.documentElement.classList.remove('js-no-scroll');
        });
    }

}